import React, { useState } from 'react';

function DocumentViewer({ folder, totalPages, label, onBack }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [jumpPage, setJumpPage] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleJump = () => {
    const page = parseInt(jumpPage);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setJumpPage('');
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* 🔵 Top Bar */}
      <div
        className="p-4 border-b flex justify-between items-center"
        style={{ backgroundColor: 'white' }}
      >
        <button
          onClick={onBack}
          style={{
            backgroundColor: '#2563eb',
            color: 'white',
          }}
          className="hover:bg-blue-700 px-4 py-2 rounded"
        >
          ← Back to Home
        </button>
        <h3 className="text-2xl font-bold text-center">{label}</h3>
        <div className="w-40" />
      </div>

      {/* 🔵 Main Content */}
      <div
        className="flex-1 flex flex-col lg:flex-row justify-center items-center gap-8 p-4"
        style={{ overflow: 'hidden' }}
      >
        {/* 📄 Image */}
        <div className="flex justify-center items-center">
          <img
            src={`/${folder}/${folder}_page-${String(currentPage).padStart(4, '0')}.jpg`}
            alt={`Page ${currentPage}`}
            style={{
              maxHeight: '75vh',
              maxWidth: '90vw',
              border: '1px solid #ccc',
            }}
          />
        </div>

        {/* 🎯 Controls */}
        <div className="flex flex-col items-center gap-6">
          <div className="text-lg">
            Page {currentPage} of {totalPages}
          </div>

          {/* 🔵 Prev/Next Buttons */}
          <div className="flex gap-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                backgroundColor: currentPage === 1 ? '#d1d5db' : '#2563eb',
                color: currentPage === 1 ? '#6b7280' : 'white',
              }}
              className={`w-32 px-4 py-2 rounded ${
                currentPage === 1 ? 'cursor-not-allowed' : 'hover:bg-blue-700'
              }`}
            >
              Previous
            </button>

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              style={{
                backgroundColor:
                  currentPage === totalPages ? '#d1d5db' : '#16a34a',
                color: currentPage === totalPages ? '#6b7280' : 'white',
              }}
              className={`w-32 px-4 py-2 rounded ${
                currentPage === totalPages
                  ? 'cursor-not-allowed'
                  : 'hover:bg-green-700'
              }`}
            >
              Next
            </button>
          </div>

          {/* 🔥 Jump to Page */}
          <div className="flex gap-2 items-center">
            <input
              type="number"
              placeholder="Enter Page #"
              min="1"
              max={totalPages}
              value={jumpPage}
              onChange={(e) => setJumpPage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e') {
                  e.preventDefault();
                }
              }}
              className="border rounded px-2 py-2 w-32 text-center"
            />
            <button
              onClick={handleJump}
              style={{
                backgroundColor: '#2563eb',
                color: 'white',
              }}
              className="w-32 hover:bg-blue-700 px-4 py-2 rounded"
            >
              Go
            </button>
          </div>
        </div>
      </div>

      {/* 🔔 Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-bold mb-4">Invalid Page Number</h2>
            <p className="mb-4">
              Please enter a number between <b>1</b> and <b>{totalPages}</b>.
            </p>
            <button
              onClick={() => setShowModal(false)}
              style={{
                backgroundColor: '#2563eb',
                color: 'white',
              }}
              className="hover:bg-blue-700 px-4 py-2 rounded"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DocumentViewer;
